import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
export const GET_CLIENT_ACTIVITY = "GET_CLIENT_ACTIVITY";
const getters = {
  [GET_CLIENT_ACTIVITY]: state => {
    var _context;
    return _sortInstanceProperty(_context = _Object$values(state.clientActivity.byId)).call(_context, (a, b) => new Date(b.createdAt).valueOf() - new Date(a.createdAt).valueOf());
  }
};
export default getters;